import { fetchCombinedData } from '@/composables/getCollection'

export const fetchVolData = async (collectionName, userid) => {
    try {
        // Include canceled items for my-requests so users can see their canceled requests
        const includeCanceled = collectionName === 'my-requests';
        const data = await fetchCombinedData(collectionName, userid, null, includeCanceled);
        let myVolunteeringData = data[1]

        let volunteeringRequestsData = data[0]
        volunteeringRequestsData.sort((a, b) => {
            const dateA = a.date ? new Date(a.date) : null;
            const dateB = b.date ? new Date(b.date) : null;
            const timeA = a.startTime ? a.startTime.split(":").map(Number) : null;
            const timeB = b.startTime ? b.startTime.split(":").map(Number) : null;

            if (dateA === null && dateB === null) {
                return 0;
            }
            if (dateA === null) {
                return 1;
            }
            if (dateB === null) {
                return -1;
            }

            // Compare dates first
            if (dateA.getTime() !== dateB.getTime()) {
                return dateA - dateB;
            }

            // If dates are the same, compare times
            if (timeA === null && timeB === null) {
                return 0;
            }
            if (timeA === null) {
                return 1;
            }
            if (timeB === null) {
                return -1;
            }

            // Compare hours
            if (timeA[0] !== timeB[0]) {
                return timeA[0] - timeB[0];
            }

            // If hours are the same, compare minutes
            return timeA[1] - timeB[1];
        });
        return { volunteeringRequestsData, myVolunteeringData }
    } catch (error) {
        // Handle errors here
        return error
    }
}